import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=a4956cfc"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=a4956cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports